document.addEventListener("DOMContentLoaded", function () {

  const zoom = 2.5;
  const glassSize = 150;

  function initMagnifier() {
    const images = document.querySelectorAll(
      '.product__media-item img, .product-single__photo img, [data-product-media-type-image] img, .product__media img'
    );

    images.forEach(function (img) {
      if (img.dataset.magnifierInit) return;
      img.dataset.magnifierInit = "true";

      const parent = img.parentElement;
      parent.style.position = 'relative';
      parent.style.overflow = 'visible';
      parent.style.cursor = 'crosshair';

 
      const glass = document.createElement('div');
      glass.style.cssText = `
        position: absolute;
        width: ${glassSize}px;
        height: ${glassSize}px;
        border-radius: 50%;
        border: 3px solid #ffffff;
        box-shadow: 0 4px 20px rgba(0,0,0,0.35);
        pointer-events: none;
        display: none;
        z-index: 9999;
        background-repeat: no-repeat;
        background-color: #fff;
      `;
      parent.appendChild(glass);

      parent.addEventListener('mousemove', function (e) {
     
        if (!img.complete || img.naturalWidth === 0) return;

        const rect = img.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();

        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
          glass.style.display = 'none';
          return;
        }

        glass.style.display = 'block';

        const glassX = e.clientX - parentRect.left - glassSize / 2;
        const glassY = e.clientY - parentRect.top - glassSize / 2;

        glass.style.left = glassX + 'px';
        glass.style.top  = glassY + 'px';

        const bgX = (x * zoom) - (glassSize / 2);
        const bgY = (y * zoom) - (glassSize / 2);

        const src = img.dataset.src || img.currentSrc || img.src;

        glass.style.backgroundImage = `url('${src}')`;
        glass.style.backgroundSize  = `${rect.width * zoom}px ${rect.height * zoom}px`;
        glass.style.backgroundPosition = `-${bgX}px -${bgY}px`;
      });

      parent.addEventListener('mouseleave', function () {
        glass.style.display = 'none';
      });
    });
  }

  initMagnifier();

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('[data-thumbnail]') ||
      e.target.closest('.thumbnail') ||
      e.target.closest('.product__media-toggle') ||
      e.target.closest('.product__media-item--thumbnail')
    ) {
      setTimeout(initMagnifier, 400);
    }
  });

  const mediaContainer = document.querySelector('.product__media-wrapper, .product__media-list, .product-single__photos');
  if (mediaContainer) {
    const observer = new MutationObserver(function () {
      setTimeout(initMagnifier, 300);
    });
    observer.observe(mediaContainer, { childList: true, subtree: true });
  }

});